import { useEffect, useState } from 'react';
import { EVENT_POOL, makeInitialRows, relTime, type EventRow } from './landingData.ts';

function ageRow(row: EventRow): EventRow {
  const value = Number.parseInt(row.ts, 10) || 0;
  const unit = row.ts.endsWith('m') ? 60 : row.ts.endsWith('h') ? 3600 : 1;
  return { ...row, ts: relTime(value * unit + 3) };
}

export function useLandingEvents() {
  const [rows, setRows] = useState<EventRow[]>(makeInitialRows);
  const [eventCount, setEventCount] = useState(48127);

  useEffect(() => {
    const id = window.setInterval(() => {
      setRows((previous) => {
        const candidate = EVENT_POOL[Math.floor(Math.random() * EVENT_POOL.length)] ?? EVENT_POOL[0]!;
        return [{ ...candidate, ts: '0s' }, ...previous.slice(0, 5).map(ageRow)];
      });
      setEventCount((count) => count + Math.floor(1 + Math.random() * 4));
    }, 2400);

    return () => window.clearInterval(id);
  }, []);

  return { rows, eventCount };
}
